module.exports = __webpack_public_path__ + "media/images/icons/outlined/delete-row-9ca2e702793423f98c45767c4ae025ad.svg";